import { pipe } from 'ramda';
import { UserMessage } from 'api/conversations/types';
import {
  Creating,
  Deleting,
  Empty,
  Loaded,
  Loading,
  Updating,
} from 'core/state';

export type StatefulUserMessage =
  | Loaded<UserMessage>
  | Creating<UserMessage>
  | Updating<UserMessage>
  | Deleting<UserMessage>;

export type CommentsState = {
  byGuid: Record<string, StatefulUserMessage>;
  byId: Record<number, string>;
  guids: Empty | Loading | Loaded<string[]>;
};

const _empty: CommentsState = {
  byId: {},
  byGuid: {},
  guids: Empty(),
};

declare const CommentsType: unique symbol;
export type Comments = { readonly type: typeof CommentsType };

export const from = (x: Comments): CommentsState =>
  x as unknown as CommentsState;
export const to = (x: CommentsState): Comments => x as unknown as Comments;

export const empty = pipe(() => _empty, to);
